export const getReaderPdfStorageKey = (baseKey: string, options: { bookId: string; pdfId: string }) =>
        options.bookId === "informatika" && options.pdfId === "informatic"
                ? baseKey
                : `${baseKey}/${encodeURIComponent(options.bookId)}/${encodeURIComponent(options.pdfId)}`
